let timer;
export default function deBounce(setGetListParams, data) {
    clearTimeout(timer);
    timer = setTimeout(() => {
        setGetListParams(data)
    }, 500)
}